module.exports = __webpack_public_path__ + "img/aoarr-nimym.f799e8bf.png";